import { useMasonryDeeplinkInterceptor } from 'hooks/use-masonry-deeplink-interceptor/use-masonry-deeplink-interceptor.hook';
// The Plan Switcher gate (`planSwitcher$root`) signals completion by emitting a
// "/member/home" deeplink — a single-plan member is auto-selected and the
// multi-plan picker's submit both deeplink there (a zero-plan member errors and
// never completes). iOS detects this off the actual Masonry deeplink action
// rather than the current route; web mirrors that by intercepting the deeplink
// action on the shared driver, NOT by reading the react-router pathname (which
// would auto-satisfy on first render when the gate is surfaced over /home).
//
// Match the iOS semantic exactly: gate completion is `path.hasSuffix("/home")`.
// Normalize the url to its pathname (strip query/hash/trailing-slash, lowercase)
// before the suffix test so query-string, hash, trailing-slash and
// scheme/host-qualified variants of the same completion deeplink all match,
// while a deeper path like "/home/settings" does not. Deliberately NOT narrowed
// to a member-only regex — kept as a plain "/home" suffix to mirror iOS.
const HOME_COMPLETION_PATH = '/home';

/**
 * While mounted, makes the gate's "/member/home" completion deeplink run
 * `onComplete` instead of navigating. Every other deeplink keeps routing
 * normally, and the app's handler is restored on unmount. Mounting two gates
 * at once is not a supported flow: the driver's action controller is a module
 * singleton.
 */
export const usePlanSwitcherGateCompletion = (onComplete: () => void) => {
  useMasonryDeeplinkInterceptor(HOME_COMPLETION_PATH, onComplete);
};
